import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=f7c05da8&scoped=true"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=f7c05da8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c05da8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7c05da8')) {
      api.createRecord('f7c05da8', component.options)
    } else {
      api.reload('f7c05da8', component.options)
    }
    module.hot.accept("./CreateEvent.vue?vue&type=template&id=f7c05da8&scoped=true", function () {
      api.rerender('f7c05da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/calendar/components/CreateEvent.vue"
export default component.exports